import SelectC8 from './SelectC8';
import FormAnimation from './FormAnimation';

export default class GravityForm {
  constructor(el) {
    this.$this = $(el);
    this.$form = this.$this.find('.gg-contact-form__gf');
    this.$header = $('header.header');
    this.$htmlBody = $('html, body');

    this.offsetSpace = 150;

    // Initialize global SelectC8 instance
    this.globalSelectC8 = new SelectC8();

    // Selectors for select-c8 functionality
    this.selectors = {
      selectC8: '.select-c8',
      dropdownSelectC8: '.dropdown-select-c8',
      selectContainer: '.gfield--type-select, .gfield--type-multiselect',
      formSelectC8: '.form-select-c8',
      dropdownToggle: '.dropdown-toggle',
      dropdownMenu: '.dropdown-menu-c8',
      dropdownListItem: 'li.optiton-select',
      filterOption: '.filter-option',
      errorField: '.gfield_error',
      validationMessage: '.validation_message',
      gfield: '.gfield',
      errorFields: '.gfield_error input, .gfield_error textarea, .gfield_error select',
      captchaField: '.gfield--type-captcha',
      recaptchaContainer: '.ginput_recaptcha',
      ginputContainer: '.ginput_container',
      repeaterItem: '.repeater-field-item',
      gfieldChoiceInput: '.gfield-choice-input',
      gchoiceOtherControl: '.gchoice_other_control',
    };

    // Classes for select-c8 functionality
    this.classes = {
      selectC8: 'select-c8',
      selectDone: 'select-done',
      formSelectC8: 'form-select-c8',
      multiselect: 'multiselect',
      selected: 'selected',
      gfieldError: 'gfield_error',
      gfieldTypeEmail: 'gfield--type-email',
      gfieldTypeCaptcha: 'gfield--type-captcha',
      gfieldErrorSelector: 'gfield_error',
      formControl: 'form-control',
      labelAnimation: 'label-animation form-label',
    };

    // Input types for validation
    this.inputTypes = {
      email: 'email',
    };

    this.repeaterInitTimer = null;

    // Timing configurations
    this.timings = {
      formCheck: 100,
      selectC8Ready: 200,
      autoSelectDelay: 500,
      focusDelay: 350,
      scrollDelay: 50,
      scrollDuration: 700,
    };

    // Debug flag for console logs (set to false in production)
    this.debugMode = false;
  }

  init() {
    this.bindGravityFormsEvents();
    this.waitForGravityForm();
    this.initFormAnimation();
    this.bindSelectC8TriggerChange();
    this.createCustomUploadInput();
    this.bindSaveLinkEvent();
    this.bindOtherChoiceFocus();
  }

  bindGravityFormsEvents() {
    $(document).on('gform_pre_submission', (_event, formId) => {
      this.handlePreSubmission(formId);
    });

    $(document).on('gform_post_render', (_event, formId) => {
      this.handlePostRender(formId);
    });

    $(document).on('done_load_repeater.ggRepeater', () => {
      this.handleRepeaterRowAdded();
    });
  }

  handlePreSubmission(formId) {
    const $form = this.getFormElement(formId);
    if (this.isInGravityForm($form)) {
      this.saveAllSelectC8ValuesToDOM();
    }
  }

  handlePostRender(formId) {
    const $form = this.getFormElement(formId);

    if (!this.isInGravityForm($form)) {
      return;
    }

    this.saveAllSelectC8ValuesToDOM();

    setTimeout(() => {
      this.reinitializeFormComponents();
    }, 0);

    setTimeout(() => {
      this.focusFirstErrorField(formId);
    }, this.timings.formCheck);
  }

  handleRepeaterRowAdded() {
    clearTimeout(this.repeaterInitTimer);
    this.repeaterInitTimer = setTimeout(() => {
      this.initSelectC8();
      this.restoreSelectC8Values();
      this.initLabelAnimations();
      this.checkInputActiveFocus();
    }, this.timings.selectC8Ready);
  }

  checkInputActiveFocus() {
    const activeFocus = 'active-focus';
    const formControlSelector = 'input[type="text"], input[type="email"], input[type="tel"], input[type="number"], textarea';

    this.$this.find(formControlSelector).each((_i, el) => {
      const $el = $(el);
      const $gfield = $el.closest(this.selectors.gfield);
      if (!$gfield.length) {
        return;
      }
      const value = $el.val();
      if (value && value.length > 0) {
        $gfield.addClass(activeFocus);
      } else {
        $gfield.removeClass(activeFocus);
      }
    });
  }

  reinitializeFormComponents() {
    this.initSelectC8();
    this.initLabelAnimations();
    this.handleValidationClear();
    this.initFormAnimation();
    this.handleSubmitValidation();
    this.restoreSelectC8Values();
    this.createCustomUploadInput();
    this.bindOtherChoiceFocus();
  }

  waitForGravityForm() {
    if (this.$this.find('.gform_wrapper').length > 0) {
      this.initSelectC8();
      this.initLabelAnimations();
      this.bindSubmitEvent();
      this.handleSubmitValidation();
    } else {
      setTimeout(() => {
        this.waitForGravityForm();
      }, this.timings.formCheck);
    }
  }

  initFormAnimation() {
    new FormAnimation(this.$form);
  }

  scrollOnTopSection(el, customTopHeight = 150) {
    if (el && el.length) {
      const offsetEl = el.offset();
      let headerHeight = 0;
      let hieghtFilterTab = 0;
      if (this.$header.length) {
        headerHeight = this.$header.outerHeight();
      }
      if ($('.gg-filter-tabs').length) {
        hieghtFilterTab = $('.gg-filter-tabs').outerHeight() + 150;
      }
      $('html, body').animate(
        {
          scrollTop: offsetEl.top - headerHeight - hieghtFilterTab + customTopHeight,
        },
        this.timings.scrollDuration,
      );
    }
  }

  focusFirstErrorField(formId) {
    const $form = this.getFormElement(formId);

    if (!$form.length || !$form.find(`.${this.classes.gfieldErrorSelector}`).length) {
      return;
    }

    const $firstErrorField = $form.find(`.${this.classes.gfieldErrorSelector}`).first();
    const $firstErrorFieldInput = $firstErrorField.find('input, textarea, select').first();

    // Always scroll to error field to ensure it's properly positioned below header
    this.scrollOnTopSection($firstErrorField, -this.offsetSpace);

    // Focus after scroll animation starts
    if ($firstErrorFieldInput.length) {
      setTimeout(() => $firstErrorFieldInput.focus(), this.timings.focusDelay);
    }
  }

  isElementInViewport($element) {
    if (!$element || !$element.length) {
      return false;
    }

    const elementTop = $element.offset().top;
    const elementBottom = elementTop + $element.outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    // Account for header height
    let headerHeight = 0;
    if (this.$header.length) {
      headerHeight = this.$header.outerHeight();
    }

    // Element is in viewport if it's between viewport top (+ header) and bottom
    return elementBottom > (viewportTop + headerHeight) && elementTop < viewportBottom;
  }

  hagtagHandle() {
    const currentURL = window.location.origin + window.location.pathname;
    const hagtag = '#thank-you';
    const urlSlug = currentURL + hagtag;
    window.history.replaceState(null, null, urlSlug);
  }

  saveLaterHashHandle() {
    const currentURL = window.location.origin + window.location.pathname;
    const hashtag = '#save-later';
    const urlSlug = currentURL + hashtag;
    window.history.replaceState(null, null, urlSlug);
  }

  bindSaveLinkEvent() {
    $(document).on('click', '.gform_save_link', (e) => {
      const $saveLink = $(e.currentTarget);
      const $form = $saveLink.closest('form');

      if (!this.isInGravityForm($form)) {
        return;
      }

      this.saveLaterHashHandle();
    });
  }

  bindSubmitEvent() {
    // Use namespaced event to prevent duplicate bindings
    const eventNamespace = `.gformSubmit${Date.now()}`;

    // Store namespace for potential cleanup
    this.submitEventNamespace = eventNamespace;

    // Bind with namespace
    $(document).on(`gform_confirmation_loaded${eventNamespace}`, (_event, formId) => {
      const $form = $(`#gf_${formId}`);

      // Double-check: Form must belong to THIS instance AND be in a .gg-gravity-form
      const belongsToThisInstance = this.$this.find(`#gf_${formId}`).length > 0;
      const isInGravityFormWrapper = this.isInGravityForm($form);

      if (!belongsToThisInstance || !isInGravityFormWrapper) {
        return;
      }

      // Scroll to confirmation message using scrollOnTopSection
      const $formParent = $form.parents('footer .gg-contact-form__gf, .gg-application-form, .gg-contact-form, .gg-newsletter-subscribe, .gg-intermediaries-subscribe').first();
      const $formConfirmation = $formParent.find('.gform_confirmation_message, .form_saved_message_sent');
      if ($formConfirmation.length) {
        this.scrollOnTopSection($formParent, -this.offsetSpace);
        this.hagtagHandle();

        // Push GTM dataLayer event only for forms inside .gg-application-form
        const isInApplicationForm = $form.closest('.gg-application-form').length > 0;
        if (isInApplicationForm) {
          this.pushFormSubmitSuccessEvent(formId, $form);
        }
      }
    });
  }

  pushFormSubmitSuccessEvent(formId, $form) {
    // Get form name from title or aria-label attribute
    const formName = this.getFormName($form, formId);

    // Generate unique submission ID
    const submissionId = this.generateSubmissionId();

    // Push to dataLayer
    window.dataLayer = window.dataLayer || [];
    /* eslint-disable camelcase */
    window.dataLayer.push({
      event: 'gform_submit_success',
      form_id: formId,
      form_name: formName,
      submission_id: submissionId,
      source_page_url: window.location.href,
    });
    /* eslint-enable camelcase */
  }

  getFormName($form, formId) {
    // Return form ID as form name
    return `Form ${formId}`;
  }

  generateSubmissionId() {
    // Generate unique submission ID using timestamp + random string
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 9);
    return `${timestamp}-${random}`;
  }

  handleSubmitValidation() {
    // Bind submit validation to submit buttons to catch before Gravity Forms processes
    this.$this.find('.gform_wrapper form').each((_i, form) => {
      const $form = $(form);
      const $submitButtons = $form.find('input[type="submit"], button[type="submit"], input[type="button"]');

      // Remove existing click validation listener
      $submitButtons.off('click.validation');

      // Add click validation listener on submit buttons
      $submitButtons.on('click.validation', (_e) => {
        this.saveAllSelectC8ValuesToDOM();

        // Note: Scroll and focus will be handled automatically by focusFirstErrorField()
        // after Gravity Forms completes validation and re-renders the form.
        // This prevents double scrolling (once here, once on post_render).
      });
    });
  }

  handleValidationClear() {
    const errorFields = this.$this.find(this.selectors.errorFields);

    errorFields.each((_i, field) => {
      const $field = $(field);
      const $gfield = $field.closest(this.selectors.gfield);
      const validationText = $gfield.find(this.selectors.validationMessage).text().toLowerCase();
      const isRequiredError = validationText.includes('required');

      $field.off('input.validation change.validation blur.validation');

      const validateAndClear = () => {
        const fieldValue = $field.val();
        const isValid = this.validateField($field, fieldValue, isRequiredError);

        if (isValid) {
          this.clearFieldError($gfield, $field);
        }
      };

      $field.on('input.validation change.validation blur.validation', validateAndClear);
    });
  }

  validateField($field, value, isRequiredError) {
    const trimmedValue = value ? value.trim() : '';

    if (isRequiredError) {
      return trimmedValue !== '';
    }

    if (!trimmedValue) {
      return false;
    }

    const $gfield = $field.closest(this.selectors.gfield);
    const fieldType = $field.attr('type');
    const isEmailField = fieldType === this.inputTypes.email ||
      $gfield.hasClass(this.classes.gfieldTypeEmail);

    if (isEmailField) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue);
    }

    return true;
  }

  clearFieldError($gfield, $field) {
    $gfield.removeClass(this.classes.gfieldError);
    $gfield.find(this.selectors.validationMessage).remove();
    $field.removeClass(this.classes.gfieldError);
    $field.attr('aria-invalid', 'false');
    $field.removeAttr('aria-describedby');
  }

  initSelectC8() {
    this.processSelectContainers();
    this.setupGlobalSelectC8Instance();
    this.syncAllSelectC8WithCurrentValues();
  }

  processSelectContainers() {
    this.$this.find(this.selectors.selectContainer).each((_i, container) => {
      this.processSelectContainer($(container));
    });
  }

  processSelectContainer($container) {
    const $select = $container.find('select');

    if (!$select.length) {
      return;
    }

    if (this.shouldSkipRepeaterItemReinit($container, $select)) {
      return;
    }

    this.cleanupSelectC8Elements($container, $select);
    this.addSelectC8Classes($container, $select);
  }

  shouldSkipRepeaterItemReinit($container, $select) {
    const $repeaterItem = $container.closest(this.selectors.repeaterItem);
    const hasExistingDropdown = $container.find(this.selectors.dropdownSelectC8).length > 0;

    if ($repeaterItem.length && hasExistingDropdown) {
      this.syncSelectC8WithCurrentValue($select);
      return true;
    }

    return false;
  }

  cleanupSelectC8Elements($container, $select) {
    $container.find(this.selectors.dropdownSelectC8).remove();
    $select.removeClass(`${this.classes.selectC8} ${this.classes.selectDone}`);
    $container.removeClass(`${this.classes.formSelectC8} ${this.classes.multiselect}`);
  }

  addSelectC8Classes($container, $select) {
    $select.addClass(this.classes.selectC8);
    $container.addClass(this.classes.formSelectC8);
    if ($select.prop('multiple')) {
      $container.addClass(this.classes.multiselect);
    }
  }

  setupGlobalSelectC8Instance() {
    this.globalSelectC8.$callSelectC8 = $(this.selectors.selectC8);

    const needsInit = this.checkIfSelectC8NeedsInit();

    if (needsInit) {
      this.globalSelectC8.init();
    } else {
      this.globalSelectC8.renderSelectToDropdown();
    }
  }

  checkIfSelectC8NeedsInit() {
    return $(this.selectors.selectC8).length > 0 &&
      $(this.selectors.dropdownSelectC8).length === 0;
  }

  initLabelAnimations() {
    // Add label-animation class to labels
    this.$this.find('.gfield label.gfield_label').each((_i, element) => {
      const $label = $(element);

      // Skip if already has label-animation class
      if ($label.hasClass(this.classes.labelAnimation)) {
        return;
      }

      // Add label-animation class
      $label.addClass(this.classes.labelAnimation);
    });
  }

  bindSelectC8TriggerChange() {
    this.$this.on('click.selectC8Trigger', this.selectors.dropdownListItem, (e) => {
      this.handleSelectC8ItemClick($(e.currentTarget));
    });
  }

  handleSelectC8ItemClick($li) {
    if ($li.hasClass('disabled')) {
      return;
    }

    const $container = $li.closest(this.selectors.formSelectC8);
    // Multi-select fields are handled entirely by SelectC8.multiSelect().
    // Running the single-value sync here would reset the <select multiple>
    // to only the last clicked option.
    if ($container.hasClass(this.classes.multiselect)) {
      return;
    }

    const $select = $container.find('select');
    if (!$select.length) {
      return;
    }

    const index = $li.index();
    const $options = $select.find('option');
    const val = $options.eq(index).val();

    this.updateSelectValue($select, val, true); // Pass flag to prevent loop
    this.saveSelectC8Value($select, val);
    this.manageActiveFocusClass($select, val);
  }

  updateSelectValue($select, value, skipSync = false) {
    if (skipSync) {
      $select.data('skip-sync', true);
    }

    $select.val(value);
    $select.trigger('change');

    if (skipSync) {
      setTimeout(() => {
        $select.removeData('skip-sync');
      }, 0);
    }
  }

  manageActiveFocusClass($select, value) {
    const $container = $select.closest(this.selectors.selectContainer);
    const $repeaterItem = $container.closest(this.selectors.repeaterItem);

    if (!$repeaterItem.length) {
      return;
    }

    if (value && value !== '') {
      $container.addClass('active-focus');
    } else {
      $container.removeClass('active-focus');
    }
  }

  createCustomUploadInput() {
    const uploadInputs = this.$form.find('input[type="file"]');
    uploadInputs.each((_index, el) => {
      const $el = $(el);
      const parent = $el.parents('.ginput_container_fileupload');

      // Skip if already initialized
      if ($el.next('.custom-upload-input__button').length) {
        return;
      }

      const elementText = $el.attr('data-text') || 'SELECT FILES';
      const $button = $('<button type="button"></button>');
      $button.addClass('custom-upload-input__button pointer-events-auto btn btn-primary');
      const $fileText = $('<p></p>');
      $fileText.addClass('custom-upload-input__text hidden mb-0 mt-8');

      // Set button text safely
      $button.text(elementText);

      parent.after($fileText);
      $el.after($button);

      $button.on('click', () => {
        $el.trigger('click');
      });

      // Handle file selection to display selected file name
      $el.on('change', (event) => {
        const {files} = event.target;
        const iconTrash = `<button type="button" class="ml-2 custom-upload-input__clear-icon pointer-events-auto hover:text-states-300">
            <span class="dashicons dashicons-trash"  aria-hidden="true"></span><span class="sr-only">Clear selected file</span></button>`;
        if (files && files.length > 0) {
          if (files.length === 1) {
            // Single file - display the filename safely
            $fileText.text(files[0].name).removeClass('hidden');
            $fileText.append(iconTrash);
          } else {
            // Multiple files - display count safely
            $fileText.text(`${files.length} files selected`).removeClass('hidden');
          }
        } else {
          // No files selected - hide the element
          $fileText.text('').addClass('hidden');
        }
      });

      // Handle clear file button click
      $fileText.on('click', '.custom-upload-input__clear-icon', (event) => {
        event.preventDefault();
        event.stopPropagation();

        // Clear the file input value
        $el.val('');

        // Hide the file text and clear content
        $fileText.text('').addClass('hidden');

        // Trigger change event to update any other dependencies
        $el.trigger('change');
      });
    });
  }

  saveSelectC8Value($select, value) {
    const $repeaterItem = $select.closest(this.selectors.repeaterItem);
    if (!$repeaterItem.length) {
      return;
    }

    const attrName = this.getSelectAttributeName($select);
    this.saveValueToDOM($repeaterItem, $select, attrName, value);
  }

  getSelectAttributeName($select) {
    const selectIdentifier = $select.attr('name') || $select.attr('id') || 'unknown';
    return `data-select-${selectIdentifier}`;
  }

  saveValueToDOM($repeaterItem, $select, attrName, value) {
    $repeaterItem.attr(attrName, value);
    $select.attr('data-saved-value', value);
  }

  saveAllSelectC8ValuesToDOM() {
    this.$this.find(this.selectors.repeaterItem).each((_i, repeaterItem) => {
      this.saveRepeaterItemSelectValues($(repeaterItem));
    });
  }

  saveRepeaterItemSelectValues($repeaterItem) {
    const $selects = $repeaterItem.find(`${this.selectors.selectContainer} select`);

    $selects.each((_j, select) => {
      const $select = $(select);
      const value = $select.val();

      if (value) {
        const attrName = this.getSelectAttributeName($select);
        this.saveValueToDOM($repeaterItem, $select, attrName, value);
      }
    });
  }

  syncSelectC8WithCurrentValue($select) {
    if ($select.data('skip-sync')) {
      return;
    }

    const currentValue = $select.val();
    const $container = $select.closest(this.selectors.selectContainer);
    const $dropdown = $container.find(this.selectors.dropdownSelectC8);

    if (!$dropdown.length) {
      return;
    }

    const $repeaterItem = $container.closest(this.selectors.repeaterItem);
    const isInRepeater = $repeaterItem.length > 0;

    if (!this.handleEmptyValue(isInRepeater, currentValue, $container)) {
      return;
    }

    this.updateDropdownDisplay($select, $dropdown, currentValue, $container, isInRepeater);
  }

  handleEmptyValue(isInRepeater, currentValue, $container) {
    if (isInRepeater && !currentValue) {
      $container.removeClass('active-focus');
      return false;
    }

    if (!currentValue) {
      return false;
    }

    return true;
  }

  updateDropdownDisplay($select, $dropdown, currentValue, $container, isInRepeater) {
    const $selectedOption = $select.find(`option[value="${currentValue}"]`);

    if (!$selectedOption.length) {
      return;
    }

    this.updateDropdownText($dropdown, $selectedOption);
    this.updateDropdownSelectedState($dropdown, $selectedOption);

    if (isInRepeater) {
      $container.addClass('active-focus');
    }
  }

  updateDropdownText($dropdown, $selectedOption) {
    const selectedText = $selectedOption.text();
    $dropdown.find(this.selectors.filterOption).text(selectedText);
  }

  updateDropdownSelectedState($dropdown, $selectedOption) {
    const selectedIndex = $selectedOption.index();
    $dropdown.find(this.selectors.dropdownListItem)
      .removeClass(this.classes.selected)
      .eq(selectedIndex)
      .addClass(this.classes.selected);
  }

  syncAllSelectC8WithCurrentValues() {
    // Sync all SelectC8 dropdowns with their current select values
    this.$this.find(`${this.selectors.selectContainer} select`).each((_i, select) => {
      this.syncSelectC8WithCurrentValue($(select));
    });
  }

  restoreSelectC8Values() {
    this.$this.find(this.selectors.repeaterItem).each((_i, repeaterItem) => {
      this.restoreRepeaterItemSelectValues($(repeaterItem));
    });
  }

  restoreRepeaterItemSelectValues($repeaterItem) {
    const $selects = $repeaterItem.find(`${this.selectors.selectContainer} select`);

    $selects.each((_j, select) => {
      this.restoreSingleSelectValue($(select), $repeaterItem);
    });
  }

  restoreSingleSelectValue($select, $repeaterItem) {
    const attrName = this.getSelectAttributeName($select);
    const savedValue = this.getSavedValue($select, $repeaterItem, attrName);

    if (savedValue) {
      this.updateSelectValue($select, savedValue);
    }

    this.syncSelectC8WithCurrentValue($select);
  }

  getSavedValue($select, $repeaterItem, attrName) {
    return $select.attr('data-saved-value') || $repeaterItem.attr(attrName);
  }

  getFormElement(formId) {
    return $(`#gform_${formId}`);
  }

  isInGravityForm($element) {
    return $element.closest('.gg-gravity-form').length > 0;
  }

  bindOtherChoiceFocus() {
    // Remove existing event handlers to prevent duplicates
    this.$this.off('change.otherChoice', this.selectors.gfieldChoiceInput);
    this.$this.off('click.otherControl', this.selectors.gchoiceOtherControl);

    // Bind change event to all choice inputs (radio/checkbox)
    this.$this.on('change.otherChoice', this.selectors.gfieldChoiceInput, (e) => {
      const $input = $(e.currentTarget);

      // Only proceed if the input is checked
      if (!$input.is(':checked')) {
        return;
      }

      // Find the parent gfield to restore previous "Other" controls
      const $gfield = $input.closest('.gfield');

      // Find all "Other" controls in this field and restore their value if empty
      $gfield.find(this.selectors.gchoiceOtherControl).each((_i, otherControl) => {
        const $otherControl = $(otherControl);
        const $parentChoice = $otherControl.closest('.gchoice');
        const $parentInput = $parentChoice.find(this.selectors.gfieldChoiceInput);

        // If this other control's parent input is not checked and value is empty, restore "Other"
        if (!$parentInput.is(':checked') && $otherControl.val().trim() === '') {
          $otherControl.val('Other');
        }
      });

      // Find the "Other" input control near this choice input
      const $otherControl = $input.closest('.gchoice').find(this.selectors.gchoiceOtherControl);

      // If "Other" control exists, focus on it and clear value
      if ($otherControl.length > 0) {
        setTimeout(() => {
          $otherControl.focus();
          $otherControl.val('');
        }, 100);
      }
    });

    // Bind click event directly to "Other" control inputs
    this.$this.on('click.otherControl', this.selectors.gchoiceOtherControl, (e) => {
      const $otherControl = $(e.currentTarget);

      // Focus on the input
      $otherControl.focus();

      // Clear the value
      $otherControl.val('');

      // Ensure the parent radio/checkbox is checked
      const $parentChoice = $otherControl.closest('.gchoice');
      const $parentInput = $parentChoice.find(this.selectors.gfieldChoiceInput);

      if ($parentInput.length > 0 && !$parentInput.is(':checked')) {
        $parentInput.prop('checked', true).trigger('change');
      }
    });
  }

}

$('.gg-gravity-form').each((_index, el) => {
  const instance = new GravityForm(el);
  instance.init();
});
